import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import PoliticaPrivacidade from "@/PoliticaPrivacidade";
import Sucesso from "@/Sucesso";
import AdminClicks from "@/pages/AdminClicks";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/politica" element={<PoliticaPrivacidade />} />
        <Route path="/sucesso" element={<Sucesso />} />
        <Route path="/admin/cliques" element={<AdminClicks />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
